import type { Pead } from "epsm-api-types/models";

export function getForecastResult({ data }: { data: Pead }) {
	const accuracy = data.accuracy || [];

	if (!accuracy?.length) return "Pending";

	const isPredictionCorrect = accuracy.find(
		(a) => a.depends_on_type && a.drift_point === "qtr_end",
	)?.was_prediction_correct;

	return isPredictionCorrect ? "IN" : "OUT";
}
